<template>
  <div class="stats">
    <v-card flat>
      <v-card-text>
        <v-row class="justify-space-around">
          <!-- countdown-->
          <Countdown
            v-if="intakePeriod"
            :end-date="new Date(intakePeriod['bookingDueDate'])"
          />
          <!-- countdown-->

          <v-divider vertical />

          <!-- Units chart -->
          <v-col cols="12" md="5" sm="6">
            <v-card flat>
              <!-- <p class="text-center">Units Progress</p>
              <div>
                <DoughnutChart :chart-data="units" />
              </div>
              <div class="status">
                <v-row>
                  <v-col cols="12" md="6" class="text-center" id="display1">
                    <p class="percent">
                      {{ incompleteUnitsCounter }}
                    </p>
                    <p class="accent--text">Incomplete Units</p>
                  </v-col>
                  <v-col cols="12" md="6" class="text-center" id="display2">
                    <p class="percent">{{ passedUnitsCounter }}</p>
                    <p class="primary--text">Complete Units</p>
                  </v-col>
                </v-row>
              </div> -->

              <v-list shaped>
                <v-subheader>Links</v-subheader>
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, i) in minorSettings.dashboard_links"
                    :key="i"
                    class="primary-hover d-flex flex-row"
                    @click="open(item.link)"
                    color="primary lighten-6"
                  >
                    <v-list-item-avatar>
                      <v-icon>mdi-link-variant</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="">
                      <v-list-item-title> {{ item.name }} </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon>mdi-arrow-right</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import DoughnutChart from "./DoughnutChart";
import { AuthService } from "../../auth";
import Countdown from "./Countdown";
// import { VueEllipseProgress } from "vue-ellipse-progress";

export default {
  name: "DashboardStats",
  props: {
    currentRegistration: {
      type: Object,
      default: null,
    },
    currentProgramme: {
      type: Object,
      default: null,
    },
    minorSettings: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Countdown,
    // VueEllipseProgress,
  },
  data: () => ({
    styles: {
      color: "#FF99cc",
    },
  }),
  mounted() {
    this.unitsCounter;
  },
  computed: {
    studentProfileID() {
      return AuthService.user.profile_id;
    },
    applications() {
      return this.$store.getters["Application/appGetters"]("applications")
        .length;
    },
    examBookings: function () {
      return this.$store.getters["Exam/studentExamGetter"]("examBookings")
        .length;
    },
    intakePeriod() {
      return this.$store.getters["Dashboard/intakePeriods"].filter(
        (period) => period.current,
      )[0];
    },
    deadlineChart() {
      let today = this.intakePeriod ? new Date() : 0;
      let startDate = this.intakePeriod
        ? new Date(this.intakePeriod.startDate).getTime()
        : 0;
      let bookingDueDate = this.intakePeriod
        ? new Date(this.intakePeriod.bookingDueDate).getTime()
        : 0;
      if (bookingDueDate > startDate) {
        const daysLeft = Math.round(
          (bookingDueDate - today) / (1000 * 3600 * 24),
        );
        const totalDays = Math.round(
          (bookingDueDate - startDate) / (1000 * 3600 * 24),
        );
        return { daysLeft: daysLeft, totalDays: totalDays };
      } else {
        return { daysLeft: 0, totalDays: 0 };
      }
    },
    units: function () {
      return {
        labels: ["Complete Units", "Incomplete Units"],
        datasets: [
          {
            backgroundColor: ["#4caf50", "#8d021f"],
            data: [this.passedUnitsCounter, this.incompleteUnitsCounter],
          },
        ],
      };
    },
    progTotalUnits: function () {
      const totalUnits =
        this.$store.getters["Exam/studentExamGetter"]("studentResults").shift();
      return totalUnits ? totalUnits["totalUnits"] : null;
    },
    incompleteUnitsCounter() {
      let incomplete = this.progTotalUnits - this.passedUnitsCounter;
      if (incomplete < 0) incomplete = 0;
      return incomplete;
    },
    passedUnitsCounter() {
      return this.$store.getters["Exam/studentExamGetter"](
        "studentResults",
      ).filter(
        (item) =>
          item.profileID === this.studentProfileID && item.result !== "FAIL",
      ).length;
    },
  },
  methods: {
    open(link) {
      window.open(link);
    },
  },
};
</script>

<style scoped>
.primary-hover:hover {
  background-color: var(--v-listings-base);
}
.primary-hover:hover .v-icon {
  color: var(--v-primary-base);
}
.primary-hover:hover .v-list-item__title {
  color: var(--v-primary-base); /* Change to the desired text color on hover */
}
@import url("../styles/dashboard.css");
</style>
